import { render } from "./BaseCheckBox.vue?vue&type=template&id=4fa3aea4&scoped=true"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"

import "./BaseCheckBox.vue?vue&type=style&index=0&id=4fa3aea4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fa3aea4"

export default script